export interface KeyboardHandler {
  setValue: (val: string) => void;
  getValue: () => string;
  inputRef?: HTMLInputElement | null;
}

const keyboardRegistry = new Map<string, KeyboardHandler>();

export const registerKeyboardHandler = (
  id: string,
  handler: KeyboardHandler,
) => {
  keyboardRegistry.set(id, handler);
};

export const getKeyboardHandler = (id: string) =>
  keyboardRegistry.get(id) ?? null;

export const unregisterKeyboardHandler = (id: string) => {
  keyboardRegistry.delete(id);
};
